/* eslint-disable import/no-anonymous-default-export */
import React, { useRef } from "react";

import "./JobCard.scss";
import { dateFormatter } from "../../../../_helpers/dateFormatter";
import { fixImageUrl } from "../../../../_helpers/fixImageUrl";
export default ({
  jobDetail,
  onJobCardClick,
  activeJobCard,
  jobCardDivParentRef,
  onApplyClick,
  formSubmitError
}) => {
  const scrollToCardRef = useRef(null);

  if (activeJobCard) {
    if (scrollToCardRef?.current) {
      let topPos =
        scrollToCardRef?.current && scrollToCardRef.current?.offsetTop;
      jobCardDivParentRef.current.scrollTo({ top: topPos, behavior: "smooth" });
    }
  }

  return (
    <div
      className={`job-box  my-0 mb-3 p-3 border-radius-10 ${activeJobCard ? "active" : ""
        }`}
      onClick={() => onJobCardClick(jobDetail?.id)}
      ref={scrollToCardRef}
    >
      <div className="d-flex justify-content-between w-100">
        <div className="d-flex align-items-start justify-content-beetween flex-wrap w-100">
          <div className="d-flex align-items-center w-50">
            <img
              src={
                jobDetail &&
                  jobDetail?.posted_by_details &&
                  jobDetail?.posted_by_details?.company_details &&
                  jobDetail?.posted_by_details?.company_details?.logo
                  ? fixImageUrl(
                    jobDetail &&
                    jobDetail?.posted_by_details &&
                    jobDetail?.posted_by_details?.company_details &&
                    jobDetail?.posted_by_details?.company_details?.logo
                  )
                  : "/assets/images/company-logo-placeholder.png"
              }
              alt="company logo"
              className="border-radius-10 mr-3"
              style={{ width: "60px", height: "60px" }}
            />
            <div className="job-info ml-3">
              <h3 className=" mb-1 text-capitalize">
                {jobDetail?.title}
              </h3>
              <p className="text-grey-4 mb-1">
                {jobDetail?.posted_by_details &&
                  jobDetail.posted_by_details?.company_details &&
                  jobDetail.posted_by_details.company_details?.name}
              </p>
            </div>
          </div>
         
        </div>
      </div>
      <div className="mt-3">
        <span className="d-inline-block font-weight-medium rounded-pill bg-grey-4 text-dark border py-1 px-2 mr-2 mb-2">
          <span className="text-capitalize">{jobDetail?.state_name}, </span>
          <span className="text-capitalize">{jobDetail?.country_name}</span>
        </span>
        <span className="d-inline-block font-weight-medium rounded-pill bg-grey-4 text-dark border py-1 px-2 mr-2 mb-2">
          {jobDetail?.employment_type &&
            jobDetail.employment_type?.replace(/_/g, " ")}
        </span>
        <span className="d-inline-block font-weight-medium rounded-pill bg-grey-4 text-dark border py-1 px-2 mb-2">
          {jobDetail?.experience && jobDetail.experience?.replace(/_/g, " ")}
        </span>
      </div>
      <p className="skills d-flex flex-wrap mt-2">
        {Array.isArray(jobDetail?.skill_names) &&
          jobDetail?.skill_names &&
          jobDetail?.skill_names.length > 1 ? (
          <>
            {jobDetail?.skill_names &&
              Array.isArray(jobDetail?.skill_names) &&
              jobDetail?.skill_names.map((skill) => (
                <span className="skill text-dark bg-grey-4 text-nowrap border px-2 rounded-lg text-capitalize mr-2 mb-2">
                  {skill}
                </span>
              ))}
            <p className="text-muted d-inline-block">
              {Array.isArray(jobDetail?.skill_names) &&
                jobDetail?.skill_names &&
                jobDetail.skill_names.length > 6
                ? "..."
                : null}
            </p>
          </>
        ) : (
          <span className="text-grey-4">Skills Not Specified</span>
        )}
      </p>
      <div className="d-flex justify-content-between align-items-end border-top pt-3">
        <span className="text-grey-4 fs-smallest ">
          Posted {dateFormatter(jobDetail.created, new Date())}
        </span>
        <span className="d-inline-block font-weight-medium rounded-lg bg-white text-dark border py-1 px-2">
          Applicants : <span className="bg-grey rounded px-2 py-1">{jobDetail?.total_candidates}</span>
        </span>
      </div>
    </div>
  );
};
